export default [
  {
    path: '/network',
    name: 'network',
    component: r => require(['views/layout/Main'], r),
    redirect: '/network/mws',
    children: [
      {
        path: 'mws',
        name: 'network-mws',
        component: r => require(['views/mws/Main'], r)
      },
      {
        path: 'gateway/solar',
        name: 'network-gateway-solar',
        component: r => require(['views/gateway/Main'], r)
      },
      {
        path: 'gateway/smart-grid',
        name: 'network-gateway-smart-grid',
        component: r => require(['views/gateway/smart-grid'], r)
      },
      {
        path: 'node',
        name: 'network-node',
        component: r => require(['views/terminal/Main'], r)
      }
    ]
  }
]
